import { useAtom } from "jotai";
import { useAtomValue, atomFamily, atomWithStorage } from "jotai/utils";

import { DataFilter } from "interfaces";

export const filtersAtom = atomFamily((fileId: string) =>
  atomWithStorage<DataFilter.Filter[]>(`data-files/filters/${fileId}`, [])
);

export const useFileFilters = (fileId: string) => useAtom(filtersAtom(fileId));

export const useGetFiltersForFile = (fileId: string) =>
  useAtomValue(filtersAtom(fileId));
